/**
 * @generated SignedSource<<78922dce7aaae64757819414f0a94d92>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type DeleteUserInput = {
  clientMutationId?: string | null | undefined;
  id: string;
  reassignId?: string | null | undefined;
};
export type User_DeleteUser_Mutation$variables = {
  input: DeleteUserInput;
};
export type User_DeleteUser_Mutation$data = {
  readonly deleteUser: {
    readonly deletedId: string | null | undefined;
  } | null | undefined;
};
export type User_DeleteUser_Mutation = {
  response: User_DeleteUser_Mutation$data;
  variables: User_DeleteUser_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deletedId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "User_DeleteUser_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteUserPayload",
        "kind": "LinkedField",
        "name": "deleteUser",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "RootMutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "User_DeleteUser_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteUserPayload",
        "kind": "LinkedField",
        "name": "deleteUser",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteRecord",
            "key": "",
            "kind": "ScalarHandle",
            "name": "deletedId"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2a354907d411cfc11e48b817b8e2e337",
    "id": null,
    "metadata": {},
    "name": "User_DeleteUser_Mutation",
    "operationKind": "mutation",
    "text": "mutation User_DeleteUser_Mutation(\n  $input: DeleteUserInput!\n) {\n  deleteUser(input: $input) {\n    deletedId\n  }\n}\n"
  }
};
})();

(node as any).hash = "f5ea6f72ed96c856a61dd538e8906fac";

export default node;
